module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveQuestion.apply(null, arguments)
      }
    }
  }, [_c('mu-card', {
    attrs: {
      "id": "create-question"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.questionCreateTitle'),
      "titleClass": "blueTitle largeTitle titleRemovePadding"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('div', {
    staticClass: "communityText",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.questionCreateSubTitle'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required',
      "data-vv-name": "question",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.questionCreateLabelTitle'),
      "errorText": _vm.errors.first('question'),
      "id": "focusable",
      "label": _vm.$t('message.questionCreateLabelTitle'),
      "hintText": _vm.$t('message.questionCreateTitlePlaceholder'),
      "helpText": _vm.$t('message.questionCreateTitleHelpText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.question),
      callback: function($$v) {
        _vm.$set(_vm.model, "question", $$v)
      },
      expression: "model.question"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "textarea",
    attrs: {
      "data-vv-rules": 'required',
      "data-vv-name": "content",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.questionCreateLabelText'),
      "errorText": _vm.errors.first('content'),
      "label": _vm.$t('message.questionCreateLabelText'),
      "multiLine": "",
      "rows": 3,
      "rowsMax": 6,
      "hintText": _vm.$t('message.questionCreateTextPlaceholder'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.content),
      callback: function($$v) {
        _vm.$set(_vm.model, "content", $$v)
      },
      expression: "model.content"
    }
  })], 1), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "submitBtn",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.submitText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveQuestion.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4953959b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questions/CreateQuestion/CreateQuestion.vue
// module id = 3710
// module chunks = 1